/**
 * Created by Jew on 9/12/2018.
 */
import { Component, ViewChild } from '@angular/core';
import { IdexService } from 'app/idex.service';
import { DocListComponent } from '../doclist/doclist.component';
import { TranslateService } from '@ngx-translate/core';
import { Toast } from 'app/shared/toast/toast';

@Component({
   selector: 'app-share-by-me',
   templateUrl: './share-link.component.html',
   styleUrls: ['./share-link.component.css'],
})
export class SharedLinkComponent {
   @ViewChild(DocListComponent)``
   public docList: DocListComponent;
   private q: string;
   private pos = 0;
   private size = 50;
   result: any;
   selectedItems: any[] = [];

   constructor(private service: IdexService,
               private translate: TranslateService, private toast: Toast) {}

}
